import React from 'react';
import { Link } from 'react-router-dom';

function mailtoHref(email, subjectPrefix, brandName) {
  const subject = `${brandName} - ${subjectPrefix}`;
  return `mailto:${email}?subject=${encodeURIComponent(subject)}`;
}

function ResponseNote({ text }) {
  const key = '1–2 business days';
  if (!text.includes(key)) {
    return <>{text}</>;
  }
  const [before, after] = text.split(key);
  return (
    <>
      {before}
      <strong>{key}</strong>
      {after}
    </>
  );
}

function AppContactLayout({ appSlug, config }) {
  const {
    brandName,
    logoLetter,
    subtitle,
    tagline,
    intro,
    supportEmail,
    cards,
    applicationLine,
    platform,
    responseNote,
  } = config;

  const year = new Date().getFullYear();

  return (
    <div className="app-contact">
      <header className="app-contact__header">
        <div className="container">
          <div className="app-contact__logo-mark" aria-hidden="true">
            <span className="app-contact__logo-letter">{logoLetter}</span>
          </div>
          <h1 className="app-contact__title">Contact Us</h1>
          <p className="app-contact__subtitle">{subtitle}</p>
          <p className="app-contact__tagline">{tagline}</p>
        </div>
      </header>

      <div className="container">
        <div className="app-contact__intro">
          <p>{intro}</p>
        </div>

        <div className="app-contact__cards">
          {cards.map((card) => (
            <div key={card.subject} className="app-contact__card">
              <div className="app-contact__card-icon" aria-hidden="true">
                {card.emoji}
              </div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <a
                href={mailtoHref(supportEmail, card.subject, brandName)}
                className="app-contact__card-cta"
              >
                {card.cta}
              </a>
            </div>
          ))}
        </div>

        <div className="app-contact__email-block">
          <h2>Send Us an Email</h2>
          <p>Our team typically responds within 1–2 business days.</p>
          <a href={`mailto:${supportEmail}`} className="app-contact__email-link">
            <span className="app-contact__email-icon" aria-hidden="true">
              ✉
            </span>
            {supportEmail}
          </a>
        </div>

        <div className="app-contact__response-note">
          <span className="app-contact__response-icon" aria-hidden="true">
            ⏱
          </span>
          <span>
            <ResponseNote text={responseNote} />
          </span>
        </div>

        <div className="app-contact__company">
          <h2>Company Information</h2>
          <div className="app-contact__info-row">
            <span className="app-contact__info-label">Company</span>
            <span className="app-contact__info-value">East IT Services s.r.o.</span>
          </div>
          <div className="app-contact__info-row">
            <span className="app-contact__info-label">Application</span>
            <span className="app-contact__info-value">{applicationLine}</span>
          </div>
          <div className="app-contact__info-row">
            <span className="app-contact__info-label">Platform</span>
            <span className="app-contact__info-value">{platform}</span>
          </div>
          <div className="app-contact__info-row">
            <span className="app-contact__info-label">Email</span>
            <span className="app-contact__info-value">
              <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </span>
          </div>
          <div className="app-contact__info-row">
            <span className="app-contact__info-label">Legal</span>
            <span className="app-contact__info-value">
              <Link to={`/${appSlug}/privacy-policy`}>Privacy Policy</Link>
              <span className="app-contact__info-sep"> · </span>
              <Link to={`/${appSlug}/terms-of-use`}>Terms of Use</Link>
            </span>
          </div>
        </div>
      </div>

      <footer className="app-contact__footer section-light-dark">
        <div className="container">
          <p>
            <span className="app-contact__footer-strong">East IT Services s.r.o.</span>
            <span> · {brandName}</span>
          </p>
          <p className="app-contact__footer-email">
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>
          <p className="app-contact__footer-copy">
            © {year} East IT Services s.r.o. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default AppContactLayout;
